const INVITE_PREFIX = "__ET_GAME_INVITE__:";
const RESPONSE_PREFIX = "__ET_GAME_RESPONSE__:";
const MOVE_PREFIX = "__ET_GAME_MOVE__:";
const STATUS_PREFIX = "__ET_GAME_STATUS__:";

export const CHAT_GAMES = [
  { id: "tic_tac_toe_3d", label: "Morpion 3D Arena" },
  { id: "connect_four_3d", label: "Connect Four 3D Tower" },
  { id: "duel_rps_3d", label: "RPS 3D Clash" },
  { id: "duel_rpsls_3d", label: "RPSLS 3D Quantum" },
  { id: "neon_elements_3d", label: "Elemental 3D Duel" },
  { id: "color_clash_3d", label: "Color Clash 3D" },
  { id: "symbol_wars_3d", label: "Symbol Wars 3D" },
  { id: "vector_directions_3d", label: "Vector 3D Directions" },
  { id: "high_number_3d", label: "High Number 3D" },
  { id: "low_number_3d", label: "Low Number 3D" },
  { id: "target_25_3d", label: "Target 25 3D" },
  { id: "target_50_3d", label: "Target 50 3D" },
  { id: "target_75_3d", label: "Target 75 3D" },
  { id: "precision_3d", label: "Precision 3D" },
  { id: "battle_sum_3d", label: "Battle Sum 3D" },
  { id: "dice_duel_3d", label: "Dice Duel 3D" },
  { id: "high_card_3d", label: "High Card 3D" },
  { id: "lucky_spin_3d", label: "Lucky Spin 3D" },
  { id: "turbo_roll_3d", label: "Turbo Roll 3D" },
  { id: "coin_flip_3d", label: "Coin Flip 3D" },
];

function toJson(payload) {
  try {
    return JSON.stringify(payload || {});
  } catch (_) {
    return "{}";
  }
}

function parseByPrefix(text, prefix) {
  const s = String(text || "");
  const cleaned = s.trimStart();
  if (!cleaned.startsWith(prefix)) return null;
  try {
    return JSON.parse(cleaned.slice(prefix.length));
  } catch (_) {
    return null;
  }
}

export function buildGameInvite(payload) {
  return `${INVITE_PREFIX}${toJson(payload)}`;
}

export function buildGameResponse(payload) {
  return `${RESPONSE_PREFIX}${toJson(payload)}`;
}

export function buildGameMove(payload) {
  return `${MOVE_PREFIX}${toJson(payload)}`;
}

export function buildGameStatus(payload) {
  return `${STATUS_PREFIX}${toJson(payload)}`;
}

export function parseGameInvite(text) {
  return parseByPrefix(text, INVITE_PREFIX);
}

export function parseGameResponse(text) {
  return parseByPrefix(text, RESPONSE_PREFIX);
}

export function parseGameMove(text) {
  return parseByPrefix(text, MOVE_PREFIX);
}

export function parseGameStatus(text) {
  return parseByPrefix(text, STATUS_PREFIX);
}

export function isGameProtocolMessage(text) {
  const s = String(text || "");
  const cleaned = s.trimStart();
  return (
    cleaned.startsWith(INVITE_PREFIX) ||
    cleaned.startsWith(RESPONSE_PREFIX) ||
    cleaned.startsWith(MOVE_PREFIX) ||
    cleaned.startsWith(STATUS_PREFIX) ||
    s.includes(INVITE_PREFIX) ||
    s.includes(RESPONSE_PREFIX) ||
    s.includes(MOVE_PREFIX) ||
    s.includes(STATUS_PREFIX)
  );
}

export function gameLabelById(gameId) {
  const found = CHAT_GAMES.find((g) => g.id === String(gameId || ""));
  return found?.label || "Jeu";
}
